import { render, staticRenderFns } from "./commission-page.vue?vue&type=template&id=aa9bbf16"
import script from "./commission-page.vue?vue&type=script&lang=js"
export * from "./commission-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports